import { render, staticRenderFns } from "./Angpao.vue?vue&type=template&id=f2d53eb8"
import script from "./Angpao.vue?vue&type=script&lang=js"
export * from "./Angpao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports